import { render, staticRenderFns } from "./KpiSatisfaccion.vue?vue&type=template&id=abaae958&"
import script from "./KpiSatisfaccion.vue?vue&type=script&lang=js&"
export * from "./KpiSatisfaccion.vue?vue&type=script&lang=js&"
import style0 from "./KpiSatisfaccion.vue?vue&type=style&index=0&id=abaae958&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports